import { useApiFetch } from '../api';

export function useKpiDetails() {
  return useApiFetch('/', async (callApi) => await callApi((api) => api.kpis.getV1Kpis()));
}
